export const generateRandomAppName = () => {
	const words1 = [
		"Sync",
		"Synchronizer",
		"Syncer",
		"Adapt",
		"Tunnel",
		"Product",
		"Products",
		"Market",
		"Store",
		"Shop",
	]

	const words2 = [
		"Master",
		"Adept",
		"Agent",
		"Guy",
		"Expert",
		"Tool",
		"Tools",
		"Machine",
		"App",
		"Application",
	]

	const word1 = words1[Math.floor(Math.random() * words1.length)]
	const word2 = words2[Math.floor(Math.random() * words2.length)]

	return `${word1} ${word2}`
}
